import * as React from 'react';
/* Components */
import LazyLoadImage from '../../../../marketplace/components/_common/LazyImage/LazyImage';
import FlatButton from '../../../../marketplace/components/_common/_buttons/FlatButton';
import OffSetButton from '../../../../marketplace/components/_common/_buttons/OffSetButton';

/* Styles */
import {
  container,
  title,
  heroSummary,
  membershipFee,
  membershipFee2,
  flexWrapContainer,
  flexWrapCenterContainer,
  flexItem,
  flexContainer,
  buttonContainer,
  newLogo,
  rightItemContainer,
} from '../HalfImageHeroLeft/styles';

interface HalfImageHeroProps {
  containerWidth: number;
  isLoggedIn: boolean;
  handleRouteChange: (input: string) => void;
  config: {
    headerTitle: string;
    summary1: string;
    summary2: string;
    summary3?: string;
    buttonLink1: string;
    buttonLink2: string;
    buttonText1: string;
    buttonText2: string;
    useFlatButton?: boolean;
    headerTextAlign: any;
    images: {
      logo: {
        src: string;
        alt: string;
      };
      desktop: {
        src: string;
        alt: string;
        height: number;
        width: number;
      };
      mobile: {
        src: string;
        alt: string;
        height: number;
        width: number;
      };
    };
  };
}

interface HalfImageHeroState {}

class HalfImageHeroLeftPromo extends React.PureComponent<
  HalfImageHeroProps,
  HalfImageHeroState
> {
  onClickButtonOne = () => {
    const { buttonLink1 } = this.props.config;
    this.props.handleRouteChange(buttonLink1);
  };

  onClickButtonTwo = () => {
    const { buttonLink2 } = this.props.config;
    this.props.handleRouteChange(buttonLink2);
  };

  render() {
    const { containerWidth, isLoggedIn } = this.props;
    const {
      headerTitle,
      images: { desktop, logo },
      buttonText1,
      buttonText2,
      useFlatButton,
      summary1,
      summary2,
      summary3,
      headerTextAlign,
    } = this.props.config;
    const isTablet = containerWidth < 1200;
    if (isTablet) {
      return (
        <div className={container}>
          <div className={flexContainer}>
            <div className={flexItem}>
              <LazyLoadImage
                alt={desktop.alt}
                src={desktop.src}
                height={desktop.height}
                width={desktop.width}
              />
            </div>
            <div className={flexItem}>
              <div className={rightItemContainer}>
                <div className={title} style={{ textAlign: 'center' }}>
                  <div style={{ textAlign: 'center' }}>{headerTitle}</div>
                  {summary1 && <div className={heroSummary}>{summary1}</div>}
                  {summary2 && <div className={membershipFee}>{summary2}</div>}
                  {summary3 && <div className={membershipFee2}>{summary3}</div>}
                </div>
                <div>
                  {buttonText1 && !buttonText2 ? (
                    <div
                      className={flexWrapCenterContainer}
                      style={{ padding: 24 }}
                    >
                      {useFlatButton ? (
                        <FlatButton
                          height="40px"
                          width="260px"
                          onClick={this.onClickButtonOne}
                          label={buttonText1}
                          color="white"
                          borderColor="black"
                          bgColor="black"
                        />
                      ) : (
                        <OffSetButton
                          onClick={this.onClickButtonOne}
                          color="black"
                          text={buttonText1}
                        />
                      )}
                    </div>
                  ) : (
                    <div className={flexWrapContainer}>
                      <div className={buttonContainer}>
                        <FlatButton
                          height="40px"
                          width="260px"
                          onClick={this.onClickButtonOne}
                          label={buttonText1}
                          color="white"
                          borderColor="black"
                          bgColor="black"
                        />
                      </div>
                      {isLoggedIn && (
                        <div>
                          <FlatButton
                            height="40px"
                            width="260px"
                            onClick={this.onClickButtonTwo}
                            label={buttonText2}
                            color="#1A1A1A"
                            borderColor="#1A1A1A"
                            bgColor="white"
                          />
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className={container}>
        <div className={flexContainer}>
          <div className={flexItem}>
            <LazyLoadImage
              alt={desktop.alt}
              src={desktop.src}
              height={desktop.height}
              width={desktop.width}
            />
          </div>
          {logo && (
            <div className={newLogo}>
              <img src={logo.src} alt={logo.alt} />
            </div>
          )}
          <div className={flexItem}>
            <div className={rightItemContainer}>
              <div className={title} style={{ textAlign: headerTextAlign }}>
                <div style={{ textAlign: headerTextAlign }}>{headerTitle}</div>
                {summary1 && <div className={heroSummary}>{summary1}</div>}
                {summary2 && <div className={membershipFee}>{summary2}</div>}
                {summary3 && <div className={membershipFee2}>{summary3}</div>}
              </div>
              <div>
                {buttonText1 && !buttonText2 ? (
                  <div
                    className={flexWrapContainer}
                    style={{ paddingLeft: 24 }}
                  >
                    {useFlatButton ? (
                      <FlatButton
                        height="40px"
                        width="260px"
                        onClick={this.onClickButtonOne}
                        label={buttonText1}
                        color="white"
                        borderColor="black"
                        bgColor="black"
                      />
                    ) : (
                      <OffSetButton
                        onClick={this.onClickButtonOne}
                        color="black"
                        text={buttonText1}
                      />
                    )}
                  </div>
                ) : (
                  <div className={flexWrapContainer}>
                    <div className={buttonContainer}>
                      <FlatButton
                        height="40px"
                        width="260px"
                        onClick={this.onClickButtonOne}
                        label={buttonText1}
                        color="white"
                        borderColor="black"
                        bgColor="black"
                      />
                    </div>
                    <div>
                      <FlatButton
                        height="40px"
                        width="260px"
                        onClick={this.onClickButtonTwo}
                        label={buttonText2}
                        color="#1A1A1A"
                        borderColor="#1A1A1A"
                        bgColor="white"
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default HalfImageHeroLeftPromo;
